import React, { useState, useEffect, useRef } from 'react'
import './index.scss'

export default function Select(props) {
  let { title, options, change, close, value } = props

  const [onValue, setOnValue] = useState('')

  let ulRef = useRef(null)
  let rPx = window.baseFlex.rootPx

  function confirm() {
    change(options.find(ele => ele.value === onValue) || '')
    close()
  }

  function hoverOnValue(el, value) {
    let findIndex = options.findIndex(ele => ele.value === value)
    if (~findIndex) {
      el.scrollTop = findIndex * rPx
    }
  }

  function activeOnValue(el) {
    let sTop = el.scrollTop
    let got = (sTop < rPx / 2) ? 0 : Math.floor((sTop - rPx / 2) / rPx) + 1
    setOnValue(options[got].value)
  }

  useEffect(() => {

    let selectUl = ulRef.current
    let timerScroll = null
    let moving = false

    selectUl.onscroll = runTimer

    function runTimer() {
      clearTimeout(timerScroll)
      timerScroll = setTimeout(() => {
        if (moving) return runTimer();
        let selectUl = ulRef.current
        let topH = selectUl.scrollTop
        let lest = topH % rPx
        if (lest > rPx / 2) {
          selectUl.scrollTop = topH + (rPx - lest)
        } else {
          selectUl.scrollTop = topH - lest
        }
        activeOnValue(selectUl)
      }, 100)
    }

    selectUl.ontouchmove = function () {
      moving = true
    }

    selectUl.ontouchend = function () {
      moving = false
    }

    //初始化value
    if (value) {
      setOnValue(value)
      hoverOnValue(selectUl, value)
      activeOnValue(selectUl)
    } else {
      selectUl.scrollTop = 0
      setOnValue(options[0].value)
    }

    return () => {
      clearTimeout(timerScroll)
    }
  }, [title, options, change, value])

  return (<div className="Select">
    <section className="container">
      <header>
        <span className="cancel" onClick={close}>取消</span>
        {title}
        <span className="confirm" onClick={confirm}>确认</span>
      </header>

      <div className="content">
        <div className="hover">
          <ul ref={ulRef}><li></li>
            {options.map((ele, index) => (<li className={ele.value === onValue ? 'active' : ''} key={index}>{ele.label}</li>))}
            <li></li>
          </ul>
        </div>
      </div>
    </section>
  </div>)

}